import React from 'react';
import ToggleButton from './components/button/index';
const defaultItems = [];

const ToggleButtonGroup = ({
  items = defaultItems,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  selectedId = null,
  disabled = false,
  fullWidth = false,
}) => (
  <div className="ws-ui-toggle-button-group">
    {items.map((item) => (
      <ToggleButton
        {...item}
        key={item.label}
        fullWidth={fullWidth}
        selected={item.id === selectedId}
        disabled={disabled}
      />
    ))}
  </div>
);

export default ToggleButtonGroup;
